import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown, Modal, Button, Form } from "react-bootstrap";
import {
  get_AstroGallary,
  get_Single_AstroGallary,
} from "../../../store/actions/CommanAction";
import DataTable from "react-data-table-component";
import Loader from "../Loader/Loader";
import { customStyles } from "../Utility/Utility";
import profile from "../../../images/adminimg.jpg";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import swal from "sweetalert";
import { FaToggleOn } from "react-icons/fa";
import axios from "axios";

const AstrologerGallary = () => {
  const dispatch = useDispatch();
  const customerID = Number(sessionStorage.getItem("ID"));

  const Astrogallary = useSelector(
    (state) => state.feedBackReducer.GetAstrologerData
  );
  const SingleAstroGallarys = useSelector(
    (state) => state.feedBackReducer.GetSingleAstroGallery
  );

  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [loading, setloading] = useState(false);
  const [isactive, setIsactive] = useState(1);
  const [IsVerify, setIsverify] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [imageModel, setImageModel] = useState(false);
  const [astroname, setAstroname] = useState();
  const [astroid, setAstroid] = useState();
  const [SingleAstroGallary, setSingleAstroGallary] = useState([]);
  const [mobileNumber, setMobileNumber] = useState("");
  const [name, setName] = useState("");
  const [timeoutId, setTimeoutId] = useState("");

  useEffect(() => {
    setSingleAstroGallary(SingleAstroGallarys);
    const firstDisplayName =
      SingleAstroGallary?.find((item) => item.DisplayName)?.DisplayName || "";
    setAstroname(firstDisplayName);
  }, [SingleAstroGallarys]);

  useEffect(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    const formattedToday = `${yyyy}-${mm}-${dd}`;

    const defaultStartTime = `${formattedToday}`;
    const defaultEndTime = `${formattedToday}`;

    setStartTime(defaultStartTime);
    setEndTime(defaultEndTime);

    dispatch(
      get_AstroGallary(
        formattedToday,
        formattedToday,
        isactive,
        IsVerify,
        name,
        mobileNumber,
        setloading
      )
    );
  }, [dispatch]);
  const handleEditClick = (row) => {
    dispatch(get_Single_AstroGallary(row?.AstroId, IsVerify, setloading));
    setAstroid(row?.AstroId);
    setEditModal(true);
  };

  const handleSearch = () => {
    const formatDate = (dateTime) => {
      if (!dateTime) return null;
      const date = new Date(dateTime);
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    };

    const formattedStartDate = formatDate(startTime);
    const formattedEndDate = formatDate(endTime);

    const data = {
      FromDate: formattedStartDate,
      Todate: formattedEndDate,
    };

    dispatch(
      get_AstroGallary(
        data.FromDate,
        data.Todate,
        isactive,
        IsVerify,
        name,
        mobileNumber,
        setloading
      )
    );
  };
  const handleSave = async (id, newVerifyValue) => {
    const obj = {
      GalleryID: id,
      IsVerify: newVerifyValue,
      ModifiedByUser: customerID,
    };

    await AddUpdate("AstrologerGallery/Update_AstrologerGallery", obj);
    swal("Good job!", "Successfully Update", "success");
    dispatch(get_Single_AstroGallary(astroid, IsVerify));
  };

  const handleClose = () => {
    setEditModal(false);
  };
  const ImageModelClose = () => {
    setImageModel(false);
  }
  const handleImageAdd = (row) => {
    setImageModel(true);
    setAstroid(row?.AstroId)
  }

  useEffect(() => {
    if (name.length < 3 && mobileNumber.length < 3) return;

    if (timeoutId) clearTimeout(timeoutId);
    const newTimeoutId = setTimeout(() => {
      setloading(true);
      dispatch(
        get_AstroGallary(
          startTime,
          endTime,
          isactive,
          IsVerify,
          name,
          mobileNumber,
          setloading
        )
      );
    }, 500);

    setTimeoutId(newTimeoutId);

    return () => clearTimeout(newTimeoutId);
  }, [name, mobileNumber]);

  const handleReset = () => {
    setName("");
    setMobileNumber(" ");
    setStartTime("")
    setEndTime("")
  }



  const fileInputRef = useRef();

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) {
      console.error("File is missing!");
      return;
    }

    const formData = new FormData();
    const dataObject = {
      AstroId: astroid,
      CreatedByUser: customerID
    };

    formData.append('Data', JSON.stringify(dataObject));
    formData.append('file', file);

    await AddUpdate("AstrologerGallery/Insert_AstrologerGallery", formData);
    swal("Good job!", "Insert Successfully", "success")
    setImageModel(false)
  };



  const columns = [
    {
      name: "Astrologer Name",
      selector: (row) => row.DisplayName,
      sortable: true,
    },

    {
      name: "Mobile No.",
      selector: (row) => row.RegMobileNo,
      sortable: true,
    },
    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 50 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <div style={{ position: "absolute", top: 4, right: 50 }}>
          <Dropdown>
            <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
              <Dropdown.Item style={{ color: "black" }} onClick={() => handleEditClick(row)}>
                Images for Approved
              </Dropdown.Item>
              <Dropdown.Item style={{ color: "black" }} onClick={() => handleImageAdd(row)}>
                Add Astrologer Image
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];
  return (
    <div>
      <div className="form-group main_card">

        <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Pending Gallery Approvals</h2>
        <div className="row mt-3 ">
          <div className="col-3">
            <div className="form-group">
              <label className="form-label">Start Time</label>
              <input
                type="date"
                // className="form-control"
                value={startTime}
                onChange={(e) => setStartTime(e.target.value)}
              />
            </div>
          </div>
          <div className="col-3">
            <label className="form-label">End Time</label>
            <input
              type="date"
              // className="form-control"
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
            />
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-3">
            <label className="form-label">Mobile Number</label>
            <input
              type="text"
              // className="form-control"
              value={mobileNumber}
              placeholder="Enter mobile number"
              onChange={(e) => {
                const input = e.target.value;

                if (/^\d{0,10}$/.test(input)) {
                  setMobileNumber(input);
                }
              }}
              maxLength={10}
            />
            {
              mobileNumber.length > 0 && mobileNumber.length < 3 && (
                <span className="text-danger">Atleast write three numbers</span>
              )
            }
          </div>

          <div className="col-3">
            <label className="form-label">Name</label>
            <input
              type="text"
              // className="form-control"
              value={name}
              placeholder="Enter name"
              onChange={(e) => {
                const input = e.target.value;

                if (/^[A-Za-z\s]{0,50}$/.test(input)) {
                  setName(input);
                }
              }}
            />
            {name.length > 0 && name.length < 3 && (
              <span className="text-danger">
                Name must be at least 3 characters
              </span>
            )}
          </div>

          <div className="col-3 mt-1">
          <button className="btn btn-primary mt-3" style={{ width: "90px" }} onClick={() => handleSearch()}>
            Search
          </button>
          <button
            className="btn btn-secondary mt-3 ms-2" style={{ width: "90px" }}
            onClick={handleReset}
          >
            Reset
          </button>
          </div>

        </div>


      </div>

      <Modal show={editModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center">{astroname}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="image-container"
            style={{ height: "450px", overflowY: "scroll" }}
          >
            {SingleAstroGallary?.length > 0 ? SingleAstroGallary?.map((item) => (
              <div key={item.GalleryID} className="image-item">
                <img
                  src={`https://${item.ImageUrl}`}
                  alt="Profile"
                  className="profile-image"
                  onError={(e) =>
                    (e.target.src = "https://via.placeholder.com/150")
                  }
                />



                <Form.Group className="verify-container">
                  <Form.Label>
                    {item.IsVerify ? "Verified" : "Unverified"}
                  </Form.Label>
                  <div
                    onClick={() => handleSave(item.GalleryID, !item.IsVerify)}
                    style={{
                      cursor: "pointer",
                      fontSize: "2.0rem",
                      color: item.IsVerify ? "green" : "red",
                    }}
                  >
                    {item.IsVerify ? <FaToggleOn /> : <FaToggleOn />}
                  </div>
                </Form.Group>
              </div>
            )) : (<span style={{ textAlign: "center" }}>NO data Available</span>)}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>

        <style jsx>{`
          .grid-container {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
            gap: 20px;
            align-items: center;
          }
          .profile-image {
            width: 150px;
            height: 150px;
            border-radius: 50%;
            object-fit: cover;
          }
        `}</style>
      </Modal>


      <Modal show={imageModel} onHide={ImageModelClose} centered>
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center">Add  Image</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <input
            type="file"
            accept="image/*"
            style={{ display: 'none' }}
            ref={fileInputRef}
            onChange={handleImageChange}
          />
          <Button variant="primary"
            onClick={handleButtonClick}
          >
            Select & Upload Image
          </Button>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={ImageModelClose}>
            Close
          </Button>
        </Modal.Footer>

        <style jsx>{`
          .grid-container {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
            gap: 20px;
            align-items: center;
          }
          .profile-image {
            width: 150px;
            height: 150px;
            border-radius: 50%;
            object-fit: cover;
          }
        `}</style>
      </Modal>



      <div className="col-12 mt-2 main_card">
        {loading ? (
          <Loader />
        ) : (
          <DataTable
            dense
            data={Astrogallary || []}
            columns={columns}
            selectableRowsHighlight
            pagination
            persistTableHead={true}
            customStyles={customStyles}
            noDataComponent={"There are no data to display"}
          />
        )}
      </div>
    </div>
  );
};
export default AstrologerGallary;
